import feathersClient from "../../feathers-client";

const defaultstaffRedeploymentReasonPagination = {
    total: 100,
    $skip: 0,
    $limit: 10,
};
const defaultstaffRedeploymentReasonPaginationFilter = {
    $skip: defaultstaffRedeploymentReasonPagination.$skip,
    $limit: defaultstaffRedeploymentReasonPagination.$limit
};

export default {
    state: {
        staffRedeploymentReason: [],
        staffRedeploymentReasonPagination: defaultstaffRedeploymentReasonPagination,
        staffRedeploymentReasonFilter: defaultstaffRedeploymentReasonPaginationFilter
    },
    getters: {
        setStaffRedeploymentReasonPage: (state) => {
            const { $limit, $skip } = state.staffRedeploymentReasonPagination;
            return $skip / $limit + 1;
        }
    },
    mutations: {
        SET_STAFF_REDEPLOYMENT_REASON: (state, data) => { state.staffRedeploymentReason = data; },
        SET_STAFF_REDEPLOYMENT_PAGINATION: (state, data) => { state.staffRedeploymentReasonPagination = { ...state.staffRedeploymentReasonPagination, ...data }; },
        SET_STAFF_REDEPLOYMENT_PAGINATION_FILTER: (state, data) => { state.staffRedeploymentReasonPaginationFilter = { ...state.staffRedeploymentReasonPaginationFilter, ...data }; }
    },
    actions: {
        setStaffRedeploymentReasonListPage: ({ commit, state }, page) => {
            const $skip = (page - 1) * state.staffRedeploymentReasonPagination.$limit;
            commit('SET_STAFF_REDEPLOYMENT_PAGINATION', { $skip });
            commit('SET_STAFF_REDEPLOYMENT_PAGINATION_FILTER', { $skip });
        },

        getStaffRedeploymentReason: async ({ rootGetters, commit }, filter) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').find({
                query: {
                    $role: rootGetters.currentUserRole, // Removed $ prefix
                    ...filter
                }
            });
           
            commit('SET_STAFF_REDEPLOYMENT_REASON', results.data);
            commit('SET_STAFF_REDEPLOYMENT_PAGINATION', { total: results.total })
            
            return results.data;
        },
        createStaffRedeploymentReason: async ({ rootGetters, commit }, data) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').create(data, {
                query: {
                    $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
          
            return results;
        },
        updateStaffRedeploymentReason: async ({ rootGetters, commit }, data) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').patch(data.id, data, {
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        deleteStaffRedeploymentReason: async ({ rootGetters}, id) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').remove(id, {
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        getStaffRedeploymentReasonById: async ({ rootGetters }, id) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').get(id, {
                query: {
                  $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results
        },
        getAllStaffRedeploymentReasonForTrust: async ({ rootGetters }) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').find({
                query: {
                   $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results;
        },
        getAllStaffRedeploymentReason: async ({ rootGetters }) => {
            const results = await feathersClient.service('api/v3/redeploymentReasons').find({
                query: {
                 $role: rootGetters.currentUserRole, // Removed $ prefix
                },
            });
            return results.data;
        }
    }
}